import { CAlert, CButton, CModal, CModalBody, CModalFooter } from '@coreui/react';
import * as React from 'react';
import { IErrorMessages } from '../abstraction';
import { AppLabels } from '../core/AppLabels';

interface IProps {
	isOpen: boolean;
	onClose: () => void;
	infos: IErrorMessages;
	timeOut: number;
}

interface IState {
	timeOut: number;
}

enum PopupTypeEnum {
	information = "info",
	success = "success",
	warning = "warning",
	error = "danger"
}

// Affiche un message d'erreur sur une Popup
// 
export class KAlertPopup extends React.Component<IProps, IState> {
	public constructor(props: any) {
		super(props);

		this.state = {
			timeOut: 20,
		};
	}

	private intervalHdlr: any = null;

	//#region React Hacks

	UNSAFE_componentWillMount = () => {
		let timeOut = this.props.timeOut ? this.props.timeOut : 20;
		if (timeOut > 0) {	// Un time out est défini
			// On déclenche un timer qui sera appelé toutes les secondes
			this.intervalHdlr = setInterval(() => {
				// Ce timer va réduire le temps restant à attendre avant fermeture
				this.setState({ timeOut: this.state.timeOut - 1 }, () => {
					// Si on est arrivé à 0, on ferme la fenêtre
					if (this.state.timeOut == 0) this.onCloseClick();
				});
			}, 1000)
		}

		this.setState({ timeOut: timeOut });
	}

	// pour éviter les comportement hasardeux, on coupe le timer lorsque le composant est supprimé
	//
	componentWillUnmount = () => {
		clearInterval(this.intervalHdlr);
	}

	//#endregion 

	//#region Local Events

	// clic sur bouton fermeture
	onCloseClick = () => {
		clearInterval(this.intervalHdlr);
		if (this.props.onClose) this.props.onClose();
	}

	//#endregion 

	//#region Rendus

	render() {

		let color = PopupTypeEnum.information;
		switch (this.props.infos.type) {
			case 1: color = PopupTypeEnum.success;
				break;
			case 2: color = PopupTypeEnum.warning;
				break;
			case 3:
			case 4:
			case 5:
				color = PopupTypeEnum.error;
				break;
		}

		// On prépare le texte OK (N) avec N = temps avant fermeture auto
		//
		let okTxt = AppLabels.ok;
		if (this.state.timeOut > 0) {
			okTxt = AppLabels.okTimeOut.replace("%%t%%", this.state.timeOut.toString());
		}

		return (
			<CModal centered closeOnBackdrop={false} className={"KAlertPopup "} show={this.props.isOpen} onClose={() => this.onCloseClick()} >
				<CModalBody>
					<CAlert color={color}>
						<h4 className="alert-heading">{this.props.infos.title}</h4>

						{this.props.infos.messages[0]}
					</CAlert>
				</CModalBody>
				<CModalFooter>
					<CButton color={color} onClick={this.onCloseClick}>{okTxt}</CButton>{' '}
				</CModalFooter>
			</CModal>
		);
	}
	//#endregion
}
